import React from 'react';
import useLoginHooks from './login-hooks';
import RoundLogo from '../../Components/Logos/RoundLogo/roundLogo';
import AuthInput from '../../Components/Inputs/AuthInput/authInput';
import Button from '../../Components/Button/button';
import { ButtonTypes } from '../../Interfaces/componentTypes';
import { usePassword } from '../../Components/Inputs/input-hooks';
import Languages from '../../Components/Languages/languages';
import useLanguagesHooks from '../../Components/Languages/setLanguage-hooks';
import { useGeneralHooks } from '../../Hooks/hooks';
import MainLogo from '../../Components/Logos/mainLogo/mainLogo';
import { HidePassword, ShowPassword } from '../../Assets/Icons';
import styles from './login.module.scss';

const Login: React.FC = () => {
    const {t} = useLanguagesHooks();
    const { password, changeType } = usePassword();
    const { handleSubmit, onSubmit, register, errors, onSignUp, isLoading, isError } = useLoginHooks();
    const { largeScreen,navigate } = useGeneralHooks();

    return (
        <>
            {
                largeScreen
                    ?
                    <div className={styles.page}>

                        <div className={styles.leftSide} />
                        <div className={styles.rightSide}>
                            <div className={styles.languages}>
                                <Languages />
                            </div>
                            <RoundLogo onClick={()=>navigate('/')} />
                            <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                                <p className={styles.header}>{t('Login.Title')}</p>
                                <AuthInput
                                    register={register}
                                    registerName='username'
                                    label={t('Sign_Up.UserName')}
                                    error={errors.username}
                                />
                                <AuthInput
                                    register={register}
                                    registerName='password'
                                    label={t('Sign_Up.Password')}
                                    error={errors.password}
                                    type={password ? 'password' : 'text'}
                                    inputBoxStyles={styles.passwordInput}
                                    children={
                                        <img
                                            className={styles.inputIcon}
                                            src={password ? HidePassword : ShowPassword}
                                            alt="eyeIcon"
                                            onClick={changeType}
                                        />
                                    }
                                />
                                {
                                    isError &&
                                    <div className={styles.loginError}>
                                        {t('Errors.Login')}
                                    </div>
                                }
                                <Button
                                    type='submit'
                                    buttonType={ButtonTypes.Primery}
                                    title={t('Login.Title')}
                                    buttonStyle={styles.button}
                                    isLoading={isLoading}
                                />
                                <div className={styles.signUpBox}>
                                    <p className={styles.signUpText}>{t('Login.No_Account')}</p>
                                    <Button
                                        onClick={onSignUp}
                                        buttonType={ButtonTypes.Secondary}
                                        title={t('Sign_Up.Button')}
                                        buttonStyle={styles.button}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                    :
                    <div className={styles.mobilePage}>
                        <div className={styles.languages}>
                            <Languages />
                        </div>
                        <MainLogo
                            action={true}
                        />
                        <form onSubmit={handleSubmit(onSubmit)} className={styles.formMobile}>
                            <p className={styles.header}>{t('Login.Title')}</p>
                            <AuthInput
                                register={register}
                                registerName='username'
                                label={t('Sign_Up.UserName')}
                                error={errors.username}
                                inputBoxStyles={styles.inputMobile}
                            />
                            <AuthInput
                                register={register}
                                registerName='password'
                                label={t('Sign_Up.Password')}
                                error={errors.password}
                                type={password ? 'password' : 'text'}
                                children={
                                    <img
                                        className={styles.inputIcon}
                                        src={password ? HidePassword : ShowPassword}
                                        alt="eyeIcon"
                                        onClick={changeType}
                                    />
                                }
                            />
                            {
                                isError &&
                                <div className={styles.loginError}>
                                    {t('Errors.Login')}
                                </div>
                            }
                            <Button
                                type='submit'
                                buttonType={ButtonTypes.Primery}
                                title={t('Login.Title')}
                                buttonStyle={styles.button}
                                isLoading={isLoading}
                            />
                            <div className={styles.signUpBox}>
                                <p className={styles.signUpText}>{t('Login.No_Account')}</p>
                                <Button
                                    onClick={onSignUp}
                                    buttonType={ButtonTypes.Secondary}
                                    title={t('Sign_Up.Button')}
                                    buttonStyle={styles.button}
                                />
                            </div>
                        </form>
                    </div>
            }
        </>

    )
}

export default Login
